<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "CardModal.TaxprepStatus" | translate }}</label>
    <kendo-dropdownlist-wrapper
        name="status"
        [data]="mappedStatuses"
        [textField]="'TaxReturnStatus.Name.' + currentLanguage"
        valueField="TaxReturnStatus.Id"
        [value]="member.statusId"
        (change)="changeStatus($event.target.value)"
        class="wk-fup__field-select"
    />
</div>
<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "CardModal.Column" | translate }}</label>
    <div class="wk-fup__field-title">
        @let stepName = getStepNameFromStatusId(member.statusId) | wkTranslate;
        {{ stepName?.length > 15 ? (stepName | slice: 0 : 15) + "..." : stepName }}
        @if (stepName?.length > 15) {
            <tooltip-pds3 mode="indicator" [openDelay]="600" [closeDelay]="50" position="bottom" targetSelector=".wk-fup__field-title">
                {{ stepName }}
            </tooltip-pds3>
        }
    </div>
</div>
<div class="wk-fup__field">
    <label class="wk-fup__field-label">{{ "Report.Category" | translate }}</label>
    <kendo-dropdownlist-wrapper
        name="category"
        [data]="categories"
        [textField]="'Name.' + currentLanguage"
        valueField="Id"
        [value]="categoriesViewModel[member.id]?.isCategoryOverridden === null ? 'Unassigned' : categoriesViewModel[member.id]?.selectedCategory"
        (change)="changeCategory($event.target.value)"
        [class.overridden-value]="categoriesViewModel[member.id]?.isCategoryOverridden"
        class="wk-fup__field-select"
    />
</div>
